var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookNaked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 15C3.75 20.5625 7.8125 25.1875 13.125 26.125L13.1877 26.0748C13.1668 26.0708 13.1459 26.0667 13.125 26.0625V18.125H10.3125V15H13.125V12.5C13.125 9.6875 14.9375 8.125 17.5 8.125C18.3125 8.125 19.1875 8.25 20 8.375V11.25H18.5625C17.1875 11.25 16.875 11.9375 16.875 12.8125V15H19.875L19.375 18.125H16.875V26.0625C16.8541 26.0667 16.8332 26.0708 16.8123 26.0748L16.875 26.125C22.1875 25.1875 26.25 20.5625 26.25 15C26.25 8.8125 21.1875 3.75 15 3.75C8.8125 3.75 3.75 8.8125 3.75 15Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookNaked);
export default __webpack_public_path__ + "static/media/facebookNaked.e80b6dea8c0dac72a92f56a9086ba0f0.svg";
export { ForwardRef as ReactComponent };